import React, { useEffect, useContext, useState, useRef } from 'react'
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import {
  Box,
  Button,
} from '@material-ui/core';

import Row from 'react-bootstrap/Row'
import Table from 'react-bootstrap/Table'
import Container from 'react-bootstrap/Container'

import { Mail as MailIcon } from 'react-feather';
import { Edit as EditIcon } from 'react-feather';


import APIS from "../../../utils/APIS"

import SuperAdminContext from "../../../contexts/SuperAdminContext"

import TopBar from "../../../components/ui/Admin/TopBar"


const AdminClients = () => {
  const navigate = useNavigate()

  const { adminClients } = useContext(SuperAdminContext)

  const [adminClientsAff, setAdminClientsAff] = useState([])
  const [sortByValue, setSortByValue] = useState("id")
  const [sortByOrder, setSortByOrder] = useState(true)

  useEffect(() => {
    if (adminClients.length > 0) {
      sortBy(sortByValue)
    }
  }, [sortByValue, adminClients])

  const sortBy = (value) => {
    let newOrder = null;
    if (sortByValue === value) {
      newOrder = !sortByOrder
    } else {
      newOrder = true
    }

    let newArr = [...adminClients].sort(
      (a, b) => {
        if (a[value] < b[value]) {
          if (newOrder === true) {
            return -1
          } else {
            return 1
          }
        } else {
          if (newOrder === true) {
            return 1
          } else {
            return -1
          }
        }
      }
    )

    setSortByOrder(newOrder);
    setSortByValue(value);
    setAdminClientsAff(newArr);
  }


  return (
    <>
      <Helmet>
        <title>Admin Clients Admins | TheLab</title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: 'background.grey',
          minHeight: '100%',
          py: 0,
          display:"flex",
          flexDirection:"column",
        }}
      >
        <Box
          sx={{
            flex:1,
            padding:"20px",
            backgroundColor:"background.grey",
          }}
        >
          <TopBar
            title="Liste des Comptes Clients Admins"
          >
            <Button
              variant="contained"
              sx={{ minHeight:"35px !important" }}
              onClick={() => { navigate('/admin/adminclient/add') }}
            >
              + Compte Admin
            </Button>
          </TopBar>


          <Box sx={{
            padding:"10px 10px 30px 10px",
            display:"flex",
            width:"100%",
            justifyContent:"space-evenly",
            gap:"10px",
            flexWrap:"wrap"
          }}>

            <Container style={{minWidth:'800px', width:'100%'}}>
              <Row>
                <Table style={{margin:'auto', width:'100%'}}>
                  <thead>
                    <tr style={{height:'30px'}}>
                      <th
                        onClick={() => sortBy('id')}
                        style={{cursor:'pointer', userSelect:'none', color : sortByValue === 'id' ? 'red' : 'unset'}}
                      >
                        ID
                      </th>
                      <th
                        onClick={() => sortBy('email')}
                        style={{cursor:'pointer', userSelect:'none', color : sortByValue === 'email' ? 'red' : 'unset'}}
                      >
                        Email
                      </th>
                      <th
                        onClick={() => sortBy('name')}
                        style={{cursor:'pointer', userSelect:'none', color : sortByValue === 'name' ? 'red' : 'unset'}}
                      >
                        Nom
                      </th>
                      <th
                        onClick={() => sortBy('language')}
                        style={{width:'80px', cursor:'pointer', userSelect:'none', color : sortByValue === 'language' ? 'red' : 'unset'}}
                      >
                        Langue
                      </th>
                      <th
                        onClick={() => sortBy('groupeNbr')}
                        style={{width:'80px', cursor:'pointer', userSelect:'none', color : sortByValue === 'groupeNbr' ? 'red' : 'unset'}}
                      >
                        Écoles
                      </th>
                      <th
                        onClick={() => sortBy('activated')}
                        style={{width:'80px', cursor:'pointer', userSelect:'none', color : sortByValue === 'activated' ? 'red' : 'unset'}}
                      >
                        Activé
                      </th>
                      <th style={{width:'70px'}}>Réinvit</th>
                      <th style={{width:'50px'}}>Edit</th>
                    </tr>
                  </thead>
                  <tbody>
                    {adminClientsAff?.map((user, index) => (
                      <tr key={index} style={{height:'30px', backgroundColor : index%2 == 0 ? '#F3F3F3' : 'white'}}>
                        <td style={{verticalAlign:"middle", textAlign:"center"}}>
                          {user.id}
                        </td>
                        <td style={{verticalAlign:"middle", textAlign:"center"}}>
                          {user.email}
                        </td>
                        <td style={{verticalAlign:"middle", textAlign:"center"}}>
                          {user.name}
                        </td>
                        <td style={{verticalAlign:"middle", textAlign:"center"}}>
                          {user.language}
                        </td>
                        <td style={{verticalAlign:"middle", textAlign:"center"}}>
                          {user.ecolesNbr}
                        </td>
                        <td style={{verticalAlign:"middle", textAlign:"center"}}>
                          {(user.activated === false) ? (
                            <>Non</>
                          ) : (
                            <>Oui</>
                          )}
                        </td>
                        {(user.activated === false) ? (
                          <td
                            style={{verticalAlign:"middle", textAlign:"center", paddingTop:'3px', cursor:"pointer"}}
                            onClick={() => {
                              APIS.resendInvitForAdminClient({id : user.id, email : user.email, language : user.language}).then((result) => {
                                if (result?.isOk === true) {
                                  alert("Invitation envoyée")
                                } else {
                                  alert("Erreur !")
                                }
                              })
                            }}
                          >
                            <MailIcon
                              color="black"
                              size={20}
                            />
                          </td>
                        ) : (
                          <td></td>
                        )}
                        <td
                          style={{verticalAlign:"middle", textAlign:"center", paddingTop:'3px', cursor:"pointer"}}
                          onClick={() => {
                            navigate('/admin/adminclient/edit/'+user.id)
                          }}
                        >
                          <EditIcon
                            color="black"
                            size={20}
                          />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </Row>
            </Container>


          </Box>

        </Box>
      </Box>
    </>
  )
};

export default AdminClients;
